import * as _ from 'lodash';
import {
    CLEAR_STORE,
    TEMP_SAVE_COGNITO_USER,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    CLEAR_USER_LOGIN_ERROR,
    SET_USER_LOGIN_ERROR,
    USER_LOGIN,
    USER_LOGIN_FAIL,
    FETCH_MY_PROFILE_SUCCESS,

    COMPANY_NOTICE_SEEN_SUCCESS,
    RECEIVE_NOTICE_COMPANY_NOTIFICATION,

    FETCH_COMPANY_USERS,
    FETCH_COMPANY_USERS_SUCCESS,
    FETCH_COMPANY_USERS_ERROR,

    CREATE_USER,
    CREATE_USER_SUCCESS,
    CREATE_USER_ERROR,

    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_REQUEST_SUCCESS,
    FORGOT_PASSWORD_REQUEST_ERROR,
    FORGOT_PASSWORD_CONFIRM_ERROR,


    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_ERROR,
    CLEAR_CHANGE_PW_ERROR,

    UPDATE_USER_PROFILE,
    UPDATE_USER_PROFILE_SUCCESS,
    UPDATE_USER_PROFILE_FAIL,

    USER_REGISTER,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL
} from "../actions/types";

const INITIAL_STATE = {
    userId: '',
    name: '',
    profilePic: 'https://react.semantic-ui.com/images/avatar/large/patrick.png',
    tempCognitoUser: null,
    isLoggedIn: false,
    isAdmin: false,
    companyId: '5d64b342e5a5d34b86a05621',
    isLoadingLogin: false,
    errorMessage: '',
    isInErrorMessage: false,

    specialNotices: [],

    companyUsers: [],
    isLoadinCompanyUsers: false,
    isLoadingAddNewUser: false,

    isLoadingChangePw: false,
    changePwError: null,

    isUpdatingUserProfile: false,

    companyData: {},

    loadingRegistering: false
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CLEAR_USER_LOGIN_ERROR:
            return {
                ...state,
                isLoadingLogin: false,
                errorMessage: '',
                isInErrorMessage: false,
            }
        case SET_USER_LOGIN_ERROR:
            return {
                ...state,
                errorMessage: action.payload.errorMessage,
                isInErrorMessage: true
            }
        case USER_LOGIN:
            return {
                ...state,
                isLoadingLogin: true,
                errorMessage: '',
                isInErrorMessage: false,
            }
        case CLEAR_STORE:
            return {
                ...INITIAL_STATE,
                isFirstTime: state.isFirstTime
            }
        case TEMP_SAVE_COGNITO_USER:
            return {
                ...state,
                tempCognitoUser: action.payload.user,
                isLoadingLogin: false,
                errorMessage: '',
                isInErrorMessage: false,
            }
        case LOGIN_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                isAdmin: action.payload.isAdmin,
                isLoadingLogin: false,
                errorMessage: '',
                isInErrorMessage: false,
            }
        case USER_LOGIN_FAIL:
            return {
                ...state,
                isLoadingLogin: false,
                errorMessage: action.payload.errorMessage,
                isInErrorMessage: true,
            }
        case LOGOUT_SUCCESS:
            return INITIAL_STATE

        case FETCH_MY_PROFILE_SUCCESS:
            return {
                ...state,
                ...action.payload
            }
        case COMPANY_NOTICE_SEEN_SUCCESS:
            let clone = [...state.specialNotices]
            _.map(clone, (notice) => {
                if (notice.id === action.payload.id) {
                    notice.isSeen = true
                }
            })
            return {
                ...state,
                specialNotices: clone
            }
        case RECEIVE_NOTICE_COMPANY_NOTIFICATION:
            return {
                ...state,
                specialNotices: [...state.specialNotices, action.payload]
            }
        case FETCH_COMPANY_USERS:
            return {
                ...state,
                isLoadinCompanyUsers: true
            }
        case FETCH_COMPANY_USERS_SUCCESS:
            return {
                ...state,
                companyUsers: action.payload.users,
                isLoadinCompanyUsers: false
            }
        case FETCH_COMPANY_USERS_ERROR:
            return {
                ...state,
                isLoadinCompanyUsers: false
            }
        case CREATE_USER:
            return {
                ...state,
                isLoadingAddNewUser: true
            }
        case CREATE_USER_SUCCESS:
            return {
                ...state,
                isLoadingAddNewUser: false
            }
        case CREATE_USER_ERROR:
            return {
                ...state,
                isLoadingAddNewUser: false
            }
        case FORGOT_PASSWORD_REQUEST:
            return {
                ...state,
                isLoadingLogin: true,
                errorMessage: '',
                isInErrorMessage: false,
            }
        case FORGOT_PASSWORD_REQUEST_SUCCESS:
            return {
                ...state,
                isLoadingLogin: false,
                errorMessage: '',
                isInErrorMessage: false
            }
        case FORGOT_PASSWORD_REQUEST_ERROR:
            return {
                ...state,
                isLoadingLogin: false,
                errorMessage: action.payload.errorMessage,
                isInErrorMessage: true,
            }
        case FORGOT_PASSWORD_CONFIRM_ERROR:
            return {
                ...state,
                isLoadingChangePw: false,
                changePwError: action.payload.errorMessage
            }
        case CHANGE_PASSWORD:
            return {
                ...state,
                isLoadingChangePw: true,
                changePwError: null
            }
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoadingChangePw: false
            }
        case CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                isLoadingChangePw: false,
                changePwError: action.payload.error
            }
        case CLEAR_CHANGE_PW_ERROR:
            return {
                ...state,
                isLoadingChangePw: false,
                changePwError: null
            }
        case UPDATE_USER_PROFILE:
            return {
                ...state,
                isUpdatingUserProfile: true
            }
        case UPDATE_USER_PROFILE_SUCCESS:
            let temp = state.companyData
            temp = { ...temp, ...action.payload.companyData }
            return {
                ...state,
                isUpdatingUserProfile: false,
                companyData: temp
            }
        case UPDATE_USER_PROFILE_FAIL:
            return {
                ...state,
                isUpdatingUserProfile: false
            }
        case USER_REGISTER:
            return {
                ...state,
                loadingRegistering: true
            }
        case USER_REGISTER_SUCCESS:
            return {
                ...state,
                companyData: action.payload.company,
                loadingRegistering: false
            }
        case USER_REGISTER_FAIL:
            return {
                ...state,
                loadingRegistering: false
            }
        default:
            return state
    }
}
